import React from 'react'
import { useNavigate } from 'react-router-dom'
import {cambiar} from "./Containerplatos";


const Boton = (props) => {
  const navigate= useNavigate()

  function miFunc() {
    cambiar(props.reff);
  }

  return (
      
    <div className="DivBotonoes">
    <button name={props.nombre}  onClick={miFunc} className="BotonMenu" > <img className="boton" src={props.imagen} alt=""/></button>
    <p className="TexBoton">{props.data}</p>
    </div> 
    

  )
}

export default Boton

/*
const navigate= useNavigate()

  function miFunc(ref) {
    navigate('/')
  }

onClick={miFunc(props.reff)} 
*/